export default __webpack_public_path__ + "static/banner-mobile-new-fcb9604913d805b3ede9eb1befc1e6b4.svg";